import type {IncentiveTier} from 'Types/incentiveTier/incentiveTierTypes';
import {TierType} from 'Types/incentiveTier/incentiveTierTypes';
import {formatPercentage} from 'Utility/formatters/percentage';

const formatFreeShares = (tier: IncentiveTier): string[] => {
  if (tier.freeShares && tier.freeShares > 0) {
    return [`${tier.freeShares} free shares`];
  }
  return [];
};

const formatDiscount = (tier: IncentiveTier): string[] => {
  if (tier.discountPercentage && tier.discountPercentage > 0) {
    const discount = formatPercentage(tier.discountPercentage);
    return [`${discount}% discount on the share price`];
  }
  return [];
};

const tierFormatters = {
  [TierType.TIME]: formatDiscount,
  [TierType.FREE_SHARES]: formatFreeShares,
  [TierType.FREE_SHARES_CODES]: formatFreeShares,
} as const;

const getLeadingItems = (incentiveTier: IncentiveTier): string[] => {
  const formatter = tierFormatters[incentiveTier.tierType];
  if (formatter) {
    return formatter(incentiveTier);
  }
  return [];
};

export const formatMerchandiseList = (
  incentiveTier: IncentiveTier
): string[] => {
  const leadingItems = getLeadingItems(incentiveTier);

  const merchandiseList = incentiveTier.merchandiseList || [];
  return [...leadingItems, ...merchandiseList];
};
